$(window).on('load', function() {
	$(function(){
		$('.js-fade01').waypoint(function(direction){
				var activePoint = $(this.element);
				if (direction === 'down') { //scroll down
						activePoint.addClass('animate__fadeInUp animate__animated');
				}
		},{offset : '70%'});
	});

	$(function(){
		$('.js-anim01').waypoint(function(direction){
				var activePoint = $(this.element);
				if (direction === 'down') { //scroll down
						activePoint.addClass('active');
				}
		},{offset : '70%'});
	});
});
